export default "__VITE_ASSET__xtFS4HRv__"